<script setup lang="ts">
import SmallModel from "@/components/Interface/Modal/ModelSizes/SmallModel.vue";
import FormSelect from '@/components/Elements/Forms/FormSelect.vue'
import {useGameStore} from "@/stores/gameStore.ts";
import Backend from '@/models/backend.ts'
import {useShipDesignStore} from "@/stores/shipDesignStore.ts";
import { computed, ref } from 'vue'
import { useFleetStore } from '@/stores/fleetStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import GenericIconWithNumber from '@/components/Elements/Images/Icons/GenericIconWithNumber.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

// Get the planet data
const gameStore = useGameStore()
const shipDesignStore = useShipDesignStore()
const fleetStore = useFleetStore()

const backend = new Backend()

const targetFleetId = ref(0)
const queuePosition = ref('end_of_queue')

const fleetOptions = computed(() => [
  { value: 0, label: t('modals.buildShip.noFleet') },
  ...[...fleetStore.fleets.values()]
    .filter(fleet => fleet && typeof fleet.name === 'string' && fleet.name.trim())
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((fleet) => ({ value: fleet.id, label: fleet.name }))
])

const queuePositionOptions = computed(() => [
  { value: 'after_current', label: t('modals.buildBuilding.queueOptions.afterCurrent') },
  { value: 'end_of_queue', label: t('modals.buildBuilding.queueOptions.endOfQueue') },
  { value: 'replace_clear', label: t('modals.buildBuilding.queueOptions.replaceClear') },
  { value: 'replace_keep', label: t('modals.buildBuilding.queueOptions.replaceKeep') }
])

// Handle form submission
const setProductionObject = (designId:number, count:number) => {
  backend.setPlanetProductionObjectShip(gameStore.modalData.planetIds, designId, count, targetFleetId.value, queuePosition.value);
  if(gameStore.modalData.planetIds.length > 1) {
    gameStore.setTinySuccessToastMessage(t('modals.buildShip.addedToQueueMultiple'));
  } else {
    gameStore.setTinySuccessToastMessage(t('modals.buildShip.addedToQueue'));
  }
}

</script>

<template>
  <SmallModel :title="t('modals.buildShip.title')">
    <div class="">
      <div style="max-height: 25rem;" class="overflow-y-scroll bg-metal-950 pt-0.5">
        <template v-for="design in [...shipDesignStore.playerShipDesigns.values()].sort((a, b) => b.id - a.id)" :key="design.id">
          <div v-if="!design.deleted" class="flex h-12 bg-metal-900 mb-0.5 items-center">
            <div class="px-2 text-metal-300 text-left flex-1">
              {{ design.name }}
            </div>
            <div class="px-2 flex justify-end items-center">
              <ActionButton @click="setProductionObject(design.id,1)">
                <GenericIconWithNumber :amount="design.productionCost" type="production" text-color="text-metal-300"/>
              </ActionButton>
              <div class="pr-2"></div>
              <ActionButton @click="setProductionObject(design.id,10)">x10</ActionButton>
            </div>
          </div>
        </template>
      </div>
      <div class="pt-2 text-subtext">
        <div class="pb-2 flex justify-center">
          <div class="flex items-center">{{ t('modals.buildShip.assignTo') }}</div>
          <div class="ps-2">
            <FormSelect
              v-model="targetFleetId"
              :options="fleetOptions"
            />
          </div>
        </div>
      </div>
      <div class="flex justify-center pb-2 text-subtext">
        <div class="flex items-center pr-2">{{ t('modals.buildShip.queuePosition') }}</div>
        <div class="ps-2">
          <FormSelect
            v-model="queuePosition"
            :options="queuePositionOptions"
          />
        </div>
      </div>
    </div>
  </SmallModel>
</template>


<style scoped lang="scss">
</style>